var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgYen = function SvgYen(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_3"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_4",
    d: "m12,0c-6.63673,0 -12,5.36327 -12,12s5.36327,12 12,12s12,-5.36327 12,-12s-5.36327,-12 -12,-12zm0,22.00653c-5.5151,0 -10.00653,-4.49143 -10.00653,-10.00653s4.49143,-10.00653 10.00653,-10.00653s10.00653,4.49143 10.00653,10.00653s-4.49143,10.00653 -10.00653,10.00653z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_5",
    d: "m14.74775,12.75429c0.4751,0 0.85714,-0.38204 0.85714,-0.85714c0,-0.4751 -0.38204,-0.85714 -0.85714,-0.85714l-1.03347,0l1.88571,-2.92898c0.25469,-0.39673 0.14204,-0.93061 -0.25469,-1.18531s-0.93061,-0.14204 -1.18531,0.25469l-2.16,3.3551l-2.16,-3.3502c-0.25469,-0.39673 -0.78857,-0.51429 -1.18531,-0.25469c-0.39673,0.25469 -0.51429,0.78857 -0.25469,1.18531l1.88571,2.92898l-1.03837,0c-0.4751,0 -0.85714,0.38204 -0.85714,0.85714s0.38204,0.85714 0.85714,0.85714l1.89061,0l0,0.83755l-1.89061,0c-0.4751,0 -0.85714,0.38204 -0.85714,0.85714s0.38204,0.85714 0.85714,0.85714l1.89061,0l0,1.04816c0,0.4751 0.38204,0.85714 0.85714,0.85714c0.4751,0 0.85714,-0.38204 0.85714,-0.85714l0,-1.04816l1.89061,0c0.4751,0 0.85714,-0.38204 0.85714,-0.85714s-0.38204,-0.85714 -0.85714,-0.85714l-1.89061,0l0,-0.83755l1.89551,0l0,-0.0049z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_13"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_14"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_15"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_16"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_17"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_18"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_19"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_20"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yen.5a4c98da.svg";
export { ForwardRef as ReactComponent };